export default __webpack_public_path__ + "static/media/5_of_diamonds.ced27ce3.png";